module.exports = __webpack_public_path__ + "static/media/info.4d70e77b.svg";